module.exports = __webpack_public_path__ + "img/4.a85a6666.png";